import { createSlice } from '@reduxjs/toolkit';

export const customCounsellingTwoSlice = createSlice({
  name: 'customCounsellingTwo',
  initialState: {
    allDataTwo: null,
  },
  reducers: {
    setAllDataTwo: (state, action) => {
      state.allDataTwo = action.payload;
    },
  },
});

export const { setAllDataTwo } = customCounsellingTwoSlice.actions;
export default customCounsellingTwoSlice.reducer;
